export default {
    setAllUsers(state, payloadUsers) {
        state.listUsers = payloadUsers;
    },
    teacherSetMyAttendanceByMonth(state, payloadAttendance) {
        state.teacherMyAttendanceByMonth = payloadAttendance.attendance;
    },
    setSchoolAccessList(state, list) {
        state.schoolAccessList = list;
    },
    updateSchoolAccessEntry(state, { schoolId, canAccess }) {
        const entry = state.schoolAccessList.find(
            (sa) => sa.school._id === schoolId
        );
        if (entry) entry.canAccess = canAccess;
    },
    setMySubscriptions(state, subscriptions) {
        state.mySubscriptions = subscriptions;
    }
}